import { AuthPageShell } from '@repo/ui/modules/auth/components/auth-page-shell'
import {
	createFileRoute,
	isRedirect,
	Outlet,
	redirect
} from '@tanstack/react-router'
import { adminSessionQueryOptions } from '@/query/query-options'
import { AuthAside } from './-components/auth-aside'

export const Route = createFileRoute('/(auth)')({
	ssr: false,
	beforeLoad: async ({ context }) => {
		// Cache-first on purpose: this layout re-runs on every child navigation
		// and preload, so it must never fetch when the session is already cached.
		// The cache is kept accurate by the auth events themselves (sign-in flows
		// run fetchFreshSession, logout and 401 recovery clear the cache).
		try {
			const session = await context.queryClient.fetchQuery(
				adminSessionQueryOptions()
			)

			if (session.sessionType === 'authenticated') {
				throw redirect({ to: '/' })
			}
		} catch (error) {
			if (isRedirect(error)) {
				throw error
			}
			// Best-effort check: the auth pages must render even when the
			// session fetch fails.
		}
	},
	// Auth split-screen: the aside is constant across every auth screen, so the
	// shell lives here in the layout. To vary the aside per page, move
	// <AuthPageShell> into each page (with its own aside) and keep only the guard
	// here.
	component: () => (
		<AuthPageShell aside={<AuthAside />}>
			<Outlet />
		</AuthPageShell>
	)
})
